import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '../../contexts/AuthContext';
import { AlertCircle, Send } from 'lucide-react';
import toast from 'react-hot-toast';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const { user, isEmailVerified, resendVerificationEmail } = useAuth();
  const [resending, setResending] = useState(false);

  const handleResend = async () => {
    setResending(true);
    const result = await resendVerificationEmail();
    if (result.success) {
      toast.success(result.message);
    } else {
      toast.error(result.message);
    }
    setResending(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
      
      {/* Overlay for mobile */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 dark:bg-opacity-70 z-20 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      
      <main className="lg:ml-64 pt-16 transition-all duration-300">
        {!isEmailVerified && user && (
          <div className="bg-amber-50 dark:bg-amber-900/20 border-b border-amber-200 dark:border-amber-800/50 px-4 py-3">
            <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3">
              <div className="flex items-center text-amber-800 dark:text-amber-300">
                <AlertCircle size={20} className="mr-2 flex-shrink-0" />
                <p className="text-sm font-medium">
                  E-posta adresiniz henüz doğrulanmamış. Lütfen e-postanızı kontrol edin.
                </p>
              </div>
              <button
                onClick={handleResend}
                disabled={resending}
                className="flex items-center px-4 py-1.5 bg-amber-100 dark:bg-amber-800/50 hover:bg-amber-200 dark:hover:bg-amber-700/50 text-amber-800 dark:text-amber-200 text-xs font-bold rounded-lg transition-colors disabled:opacity-50"
              >
                {resending ? (
                  'Gönderiliyor...'
                ) : (
                  <>
                    <Send size={14} className="mr-1.5" />
                    Tekrar Gönder
                  </>
                )}
              </button>
            </div>
          </div>
        )}
        <div className="p-4 sm:p-6">
          {children}
        </div>
      </main>
    </div>
  );
};

export default Layout;
